export default __webpack_public_path__ + "static/media/S3BucketAccessLogs.764a7308.md";